import React from 'react';

/**
 * Skip Navigation Link Component
 * Requirement: REQ-016 (UI Accessibility)
 * Provides keyboard users ability to skip repetitive navigation
 */
export const SkipNavigation: React.FC = () => {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          document.getElementById('main-content')?.focus();
        }
      }}
    >
      Zum Hauptinhalt springen
    </a>
  );
};